import React from 'react';
import Form  from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import { Screens } from '../screencontainer.js';
import ReCAPTCHA from 'react-google-recaptcha';
import { API } from '../api.js';
//import { apiURL } from '../api.js';
import { Spinner } from 'react-bootstrap';
import '../index.css';
import { VERIFY_CAPTCHA,VERIFY_EMAIL } from '../actions';


export class Verification extends React.Component {
    constructor( props ) {
        super( props );

        this.state = {
            validated: false,
            email_1: '',
            email_2: '',
            emailsMatch: true,
            captchaToken: null,
            captchaSuccessful: false,
            captchaCompleted: false,
            attemptsExceeded: false,
            errorMessage: '',
            showError: false,
            isLoading: false,
            apiURL: '',
            apiURL_QA: ''
        }

        this.reCaptchaRef = React.createRef();
    }

    onEmailChange_1 = ( event ) => {

        this.setState({
            email_1: event.target.value,
        });
    }

    onEmailChange_2 = ( event ) => {

        this.setState({
            email_2: event.target.value,
        });
    }

    onCaptchaChange = ( value ) => {
        this.setState({
            captchaToken: value,
        });
    }

    onSubmit = async ( event ) => {
        event.preventDefault();
        event.stopPropagation();

        var api = new API();

        this.setState({
            isLoading: true,
        });

        this.setState({
            emailsMatch: this.state.email_1 === this.state.email_2,
        });

        var captchaParms = {
            CaptchaToken: this.state.captchaToken
        }

        var captchaData           = api.createRequestData( VERIFY_CAPTCHA, captchaParms);
        var encryptedCaptchaData  = api.encryptData( captchaData );
        var captchaRequest        = api.createRequest( encryptedCaptchaData );
        var captchaRequestOptions = api.createRequestOptions( 'POST', captchaRequest );

        try {
            await fetch( this.state.apiURL, captchaRequestOptions )
            .then( response => response.json() )
            .then( data => {
                
                var decryptedData = api.decryptData( data[ 'Data' ] );
                var decryptedToJSON = JSON.parse( JSON.parse( decryptedData )[ 'ResponseList' ][ 'Response'] );

                var message = {
                    'msgID' : decryptedToJSON[ 'Messages' ][ 0 ][ 'MsgId' ],
                    'msgStatus' : decryptedToJSON[ 'Messages' ][ 0 ][ 'MsgStatus' ]
                }

                if ( message[ 'msgID' ] === '0' && message[ 'msgStatus' ] === 'OK' )
                {
                    var captchaResponse = {
                        'error'    : decryptedToJSON[ 'CaptchaResponseList' ][ 0 ][ 'CaptchaErrorCode' ],
                        'response' : decryptedToJSON[ 'CaptchaResponseList' ][ 0 ][ 'CaptchaResponse' ]
                    }

                    this.setState({
                        captchaSuccessful: captchaResponse[ 'response' ]
                    });
                }

                else
                {
                    this.setState({
                        captchaSuccessful: false
                    });
                }

                
                

                //FOR TESTING PURPOSE. TO BE REMOVED LATER//
                this.setState({
                    captchaSuccessful: true
                });


            });
        } catch(error) {
            throw error
        }
        //end of try catch

        if ( this.state.emailsMatch === true && 
            //  this.state.captchaSuccessful === true && 
             this.state.email_1 !== '' && 
             this.state.email_2 !== '' ) 
        {
            var requestDataParams = {
                'Email'     : this.state.email_1,
                'UserAction': this.props.userAction,
                'SessionId' : this.props.sessionID
            }

            var requestData          = api.createRequestData( VERIFY_EMAIL, requestDataParams );
            var encryptedRequestData = api.encryptData( requestData );
            var request              = api.createRequest( encryptedRequestData );
            var requestOptions       = api.createRequestOptions( 'POST', request );

            try {
                await fetch( this.state.apiURL, requestOptions )
                .then( response => response.json() )
                .then( data => {
                    var decryptedData = api.decryptData( data[ 'Data' ] );
                    var decryptedToJSON = JSON.parse( JSON.parse( decryptedData )[ 'ResponseList' ][ 'Response'] );

                    var messages = {
                        'Msg'      : decryptedToJSON[ 'Messages' ][ 0 ][ 'Msg' ],
                        'MsgStatus': decryptedToJSON[ 'Messages' ][ 0 ][ 'MsgStatus' ],
                        'GUID'     : decryptedToJSON[ 'Messages' ][ 0 ][ 'RequestGuid' ],
                        'MsgId'    : decryptedToJSON[ 'Messages' ][ 0 ][ 'MsgId' ]
                    }

                    if ( messages[ 'MsgStatus' ] === 'OK' && messages[ 'Msg' ] === 'Verification Code Sent' )
                    {
                        var addtlParams = {
                            'email'     : this.state.email_1,
                            'guid'      : messages[ 'GUID' ],
                            'sessionID' : this.props.sessionID
                        }

                        this.setState({
                            isLoading: false,
                        });

                        this.props.setScreenState( Screens.OTP_VERIFICATION, this.props.userAction, addtlParams );
                    }
                    else if ( messages[ 'MsgStatus' ] === 'ERROR' || messages['MsgStatus'] === 'FAILED' ) 
                    {
                        this.setState({
                            errorMessage: messages[ 'Msg' ],
                            showError: true,
                        });

                        if ( messages[ 'MsgId' ] === '-9999' ) // exceeded retries
                        {
                            this.setState({
                                attemptsExceeded: true,
                            });
                        }

                        this.setState({
                            isLoading: false,
                        });
                    }
                });
            }
            catch( e ) {
                console.log( e );

                this.setState({
                    isLoading: false,
                });
            }
        }
        
        if ( this.reCaptchaRef.current != null )
        {
            this.reCaptchaRef.current.reset();
        }

        this.setState({
            //captchaCompleted: false,
            validated: true,
            isLoading: false,
        });
    }

    onCancel = () => {
        this.props.setScreenState( Screens.MAIN_MENU, null, null );
    }

    render() {

        if(this.state.apiURL === '' && this.state.apiURL_QA === '') {
            this.setState({apiURL: this.props.apiURLs.apiURL, apiURL_QA: this.props.apiURLs.apiURL_QA});
        }

        var emailMatchError = this.state.emailsMatch;
        var verifiedHuman = ( this.state.captchaToken === null || this.state.captchaToken === '' ) ? false : true;

        return(
            <>
                <p className='VerificationDisclaimer'><b>{this.props.userAction }</b></p>

                <p className='VerificationDisclaimer'>
                    Your information security is our top priority. We need to verify your identity before continuing. 
                    We must email you a 5-Digits Security code for verification. Please enter your email below.
                </p>

                <Form 
                    noValidate 
                    validated={this.state.validated} 
                    onSubmit={this.onSubmit}
                    className='VerificationEmailProperties'
                >

                    <Form.Group>
                        <Form.Label> Email </Form.Label>
                        <Form.Control 
                            required 
                            type='email' 
                            className='shadow'
                            value={this.state.email_1}
                            onChange={this.onEmailChange_1}
                        />
                    </Form.Group>

                    <Form.Group>
                        <Form.Label> Verify Email </Form.Label>
                        <Form.Control 
                            required 
                            type='email' 
                            className='shadow'
                            value={this.state.email_2}
                            onChange={this.onEmailChange_2}
                        />
                    </Form.Group>

                    <p
                        hidden={emailMatchError}
                        className='VerificationEmailMatchError'   
                    >
                        Emails do not match. Please double check
                    </p>

                    {/* <ReCAPTCHA 
                        ref={this.reCaptchaRef}
                        required
                        // sitekey = '6Ld_0rMZAAAAAGUdJUgS2iUsXRLQGT055_gaVk53'
                        sitekey = '6LfZe74ZAAAAAGkTXfNYDku85m46Zl_VYVvW55u9'
                        onChange={this.onCaptchaChange}
                        size='normal'
                        className='VerificationCaptcha'
                    />

                    <p
                        hidden={verifiedHuman}
                        className='VerificationEmailMatchError'   
                    >
                        Please verify you are a human
                    </p> */}

                    <p
                        hidden={!this.state.showError}
                        className='VerificationEmailMatchError'
                        style={{marginTop:'15px'}}
                    >
                        {this.state.errorMessage}
                    </p>

                    <div className='VerificationSubmitButtonFormatting'>
                        {
                            this.state.isLoading ? 

                                <center>
                                    <Spinner animation='border' />
                                </center>

                            :

                                <Button
                                    disabled={this.state.attemptsExceeded}
                                    variant='danger'
                                    type='submit'
                                    className='VerificationSubmitButtonProperties shadow'
                                >
                                    Submit
                                </Button>
                        }

                        <Button
                            variant='link'
                            className='VerificationCancelButton'
                            onClick={this.onCancel}
                        >
                            Go Back
                        </Button>
                    </div>

                </Form>
            </>
        );
    }
}